// authStorage.js
export let memoryAccessToken = null;
const memoryAccessTokenListeners = new Set();

export function setMemoryAccessToken(newToken) {
    memoryAccessToken = newToken;
    memoryAccessTokenListeners.forEach((listener) => listener());
}

export function getMemoryAccessToken() {
    return memoryAccessToken;
}

export function clearMemoryAccessToken() {
    setMemoryAccessToken(null);
}

export function subscribeMemoryAccessToken(onChange) {
    memoryAccessTokenListeners.add(onChange);
    return () => {
        memoryAccessTokenListeners.delete(onChange);
    };
}